import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function AdmissionForm({title, formUrl, formTitle}) {
  const [loading, setLoading] = useState(true);

  const handleIframeLoad = () => {
    setLoading(false); // Hide the loader once iframe content is loaded
  };

  return (
    <section className="py-4 bg-gradient-to-b from-gray-800 via-gray-900 to-black text-gray-300 min-h-screen">
    <div className="container mx-auto px-2 flex flex-col h-full">
      {/* Header Section */}
      <header className="text-center mb-4">
        <h1 className="text-2xl font-bold text-gray-200 mb-1">{title}</h1>
        <p className="text-gray-400 mb-3">
          Please fill out the form below to apply for admission.
        </p>
      </header>
  
      {/* Embedded Google Form with Loader */}
      <div className="relative bg-gray-700 p-2 rounded-3xl shadow-md hover:shadow-lg flex-grow flex flex-col">
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75 rounded-3xl">
            <div className="loader border-t-4 border-b-4 border-primaryColor rounded-full w-12 h-12 animate-spin"></div>
          </div>
        )}
        <iframe
          src={formUrl}
          className="w-full h-[100vh] flex-grow rounded-lg border-none"
          title={formTitle}
          onLoad={handleIframeLoad} // Trigger when iframe content is loaded
        >
          Loading…
        </iframe>
      </div>
  
      {/* Footer Section */}
      <footer className="text-center mt-4 text-gray-400 ">
        <span>&copy; {new Date().getFullYear()} SchoolLine. All rights reserved.</span>
        <span className="mx-2">|</span>
        <Link
          to="/"
          className="footer-link text-primaryColor hover:text-primaryColorDark transition-colors duration-300"
        >
          Powered by SchoolLine
        </Link>
      </footer>
    </div>
  </section>
  );
}

export default AdmissionForm;